import { CircularProgress } from '@mui/material'

export const CircularSpinner = () => (
  <div className="w-full flex justify-center items-center h-20">
    <CircularProgress />
  </div>
)
